import { zodResolver } from '@hookform/resolvers/zod'
import { FieldValues, Resolver } from 'react-hook-form'
import { z } from 'zod'

/**
 * `zodResolver` typed as in `@hookform/resolvers` 2: the form values take the type given to
 * `useForm`. Version 5 types them as the schema input instead, which zod 4 widens to `unknown`
 * for preprocessed and coerced fields. Validation is unchanged.
 */
export const zodFormResolver = <TFieldValues extends FieldValues>(
  schema: z.ZodType<unknown, FieldValues>
) => zodResolver(schema) as unknown as Resolver<TFieldValues>
